import React from 'react';
import {Container} from '~/common/fabric/CreateDesign/components/Container/Container';
import {Envelope} from './Envelope';
import './Envelope.sass';
import {EnvelopeEditor} from './EnvelopeEditor';

export const EnvelopeContainer = () => (
  <Container>
    <Envelope />
    <EnvelopeEditor />
  </Container>
);
